// types
import { ClimaticFiltersType } from '../types/product-filters.type';
import { NestedFilter } from '@app/shared/types/nested-filter.type';

export const climaticFilterItems: ClimaticFiltersType = {
  filterTitles: [
    'products.acidResistance',
    'products.pressureResistance',
    'products.waterAbsorption',
    'products.frostResistance',
  ],
  filterQueryNames: [
    'metadata[acid_resistance]',
    'metadata[frost_resistance]',
    'metadata[pressure_resistance]',
    'metadata[water_absorption]',
  ],
};

export const colorFilterItems: string[] = [
  'RED',
  'WHITE',
  'BLACK',
  'YELLOW',
  'BLUE',
  'ORANGE',
  'GREEN',
];

export const stoneDesignFilterItems: NestedFilter[] = [
  {
    name: 'products.point',
    filterQueryName: 'metadata[dots]',
    items: colorFilterItems,
  },
  {
    name: 'products.vein',
    filterQueryName: 'metadata[veins]',
    items: colorFilterItems,
  },
  {
    name: 'products.halo',
    filterQueryName: 'metadata[halos]',
    items: colorFilterItems,
  },
];

export const surfaceFinishingFilterItems: string[] = ['POLISHED'];

export const stoneGradeFilterItems: string[] = ['A', 'B', 'C', 'D'];

export const monthlyProductionFilterItems: string[] = ['2', '5', '10', '20'];
